import { Typography } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";

const QuestionFooter = ({ label, children, sx = {} }) => {
  return (
    <div className="mb-1 mt-2 flex w-full items-center justify-between gap-8 text-xs">
      <Typography
        mb={0.5}
        sx={{
          ...sx,
          color: HNSColors.neutrals[100],
          fontWeight: "500",
          fontSize: "12px",
        }}
      >
        {label}
      </Typography>
      {children}
    </div>
  );
};

export default QuestionFooter;
